$(document).ready(function(){
  
    $(".block__homereview-video-container").each(function(){
        var $this = $(this);
        $this.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            nextArrow: $this.find(".block__ai-review-video-info-arrow"),
            fade: true,
            adaptiveHeight: true
        });
    });
      setTimeout(function() {
   if($(window).width() > 1023){
            $('.block__ai-review-trusted-logos').css('height',  $('.block__homereview-video-container .slick-list').innerHeight()); 
            $('.block__ai-review-trusted-logos-wrapper').css('height', $('.block__ai-review-trusted-logos').innerHeight() - $('.block__ai-review-heading').innerHeight()); 
        }    
    }, 3000); 
    $('.block__homereview-video-container').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $('.block__homereview-video-item').each(function(){
            var itemvideo = $(this).find(".block__homereview-video-boxwrap").find("video")[0];
            itemvideo.pause();
            itemvideo.removeAttribute('controls');
            $(this).find('.block__ai-review-video-boxplay').removeClass("hidden");
             itemvideo.removeAttribute('style')
        }); 
    });

    $('.block__homereview-video-container').on('afterChange', function (event, slick, currentSlide) {
        $('.block__homereview-video-item').each(function(){
            var itemvideo = $(this).find(".block__homereview-video-boxwrap").find("video")[0];
            itemvideo.pause();
            itemvideo.removeAttribute('controls');
            $(this).find('.block__ai-review-video-boxplay').removeClass("hidden");
            itemvideo.removeAttribute('style')
        });
        if($(window).width() > 1023){
        //   $('.block__ai-review-trusted-logos').css('height',  $('.block__homereview-video-container .slick-list').innerHeight()); 
          $('.block__ai-review-trusted-logos-wrapper').css('height', $('.block__ai-review-trusted-logos').innerHeight() - $('.block__ai-review-heading').innerHeight()); 
       }    
    });

    $(document).on("click",".block__ai-review-video-boxplay",function(){
        $(this).addClass("hidden");
        var current_video = $(this).parents(".block__homereview-video-boxwrap").find("video")[0];
        $(current_video).attr("controls","true")
        $(this).parents(".block__homereview-video-boxwrap").find("video")[0].play();
        // $(this).parents(".block__homereview-video-ratewrap").find(".block__homereview-video-ratebox").css('bottom','65px');
        // $(this).parents(".block__homereview-video-ratewrap").find('.block__homereview-projectlogo-info').addClass('hideprojectlogo');
        $(current_video).prop('muted', false);
        $(this).parents(".block__homereview-video-boxwrap").find("video")[0].setAttribute('style', 'position: relative; z-index:1')

        // $(this).parents(".block__homereview-video-boxwrap").find(".block__homereview-video-soundbtn").addClass('sound-on');
    });

    $(document).on("click",".block__homereview-video-soundbtn",function(){
        var current_video_btn = $(this).parents(".block__homereview-video-boxwrap").find("video")[0];
        if( $(current_video_btn).prop('muted') ) {
            $(this).addClass('sound-on');
              $(current_video_btn).prop('muted', false);
        } else {
            $(this).removeClass('sound-on');
          $(current_video_btn).prop('muted', true);
        }
    });

    function refreshSlickIfNotFullscreen() {
        if (!document.fullscreenElement && 
            !document.mozFullScreenElement && 
            !document.webkitFullscreenElement && 
            !document.msFullscreenElement) {
            console.log("Exiting fullscreen, refreshing Slick carousel.");
            setTimeout(function() {
                $(".block__homereview-video-container").slick('refresh');
            }, 500);
        }
    }
    
    document.addEventListener("fullscreenchange", function() {
        refreshSlickIfNotFullscreen();
    });
    
    document.addEventListener("mozfullscreenchange", function() {
        refreshSlickIfNotFullscreen();
    });
    
    document.addEventListener("webkitfullscreenchange", function() {
        refreshSlickIfNotFullscreen();
    });
    
    document.addEventListener("msfullscreenchange", function() {
        refreshSlickIfNotFullscreen();
    });

});